module.exports = __webpack_public_path__ + "img/slide2-percent.0fbe7b6a.png";